import {SOPostAssessment} from '../../core/assessment/so-post-assessment';
import {AssessmentCore} from './assessment.core';
import {SOGetAssessment} from '../../core/assessment/so-get-assessment';
import {FormField, SelectionOption} from 'lionheartland';
import {postAssessmentFormFieldOptions} from './post-assessment-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {ReportCore} from '../report/report.core';
import {SOGetReport} from '../../core/report/so-get-report';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostAssessment extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postAssessmentFormFieldOptions);

  RequestClass = SOPostAssessment

  constructor(
    public entityCore: AssessmentCore
  ) {
    super();
    if (postAssessmentFormFieldOptions.report) {
      postAssessmentFormFieldOptions.report.makeCore = true;
    }
    if (postAssessmentFormFieldOptions.project) {
      postAssessmentFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier(
        'report',
        SOGetReport,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}